    $(document).ready(function(){
    	$("#CategoryBox .box-heading").click(function(){
    	$("#CategoryBox #SiteCat").slideToggle(500);
    	$('#CategoryBox').toggleClass('active');
    	});
    });

    function side_cat() {
       if ($(window).width() <= 1500) {
          var max_elem = 9;
       }
       else {
         var max_elem = 13;
       }
      var items = $('#CategoryBox > ul#SiteCat > li').not('.more_menu');
      var surplus = items.slice(max_elem, items.length);
      var $more = $('#CategoryBox > ul#SiteCat > li.more_menu');
      var $dropdown = $more.find('.site-nav__childlist-grid');
      if (surplus.length) {
        $more.removeClass('is-placeholder').show();
        if (!$more.find('.site-cat-more.site-cat__link').length) {
          $more.prepend('<a class="site-cat-more site-cat__link">More Categories</a><span class="mobile_togglemenu"></span>');
        }
        if (!$more.find('.icon.icon-caret').length) {
          $more.find('.site-cat-more.site-cat__link').prepend('<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>');
        }
        $dropdown.empty().append(surplus);
      } else {
        $more.addClass('is-placeholder').hide();
      }
    }
    $(document).ready(function() {
      side_cat()
    });

    $(document).on('click', '.site-cat--has-dropdown.more_menu > .site-cat-more', function(e) {
      if ($(window).width() >= 1270) {
        e.preventDefault();
        $(this).closest('.site-cat--has-dropdown.more_menu').toggleClass('active');
      }
    });

    function sidecatresponsive() {
       if ($(window).width() <= 1269) {
          $("#CategoryBox .icon.icon-close").click(function(){
            $('#CategoryBox').removeClass('active');
            $('#CategoryBox #SiteCat').css('display','none');
          });
         $("#CategoryBox .box-heading").click(function(){
        	$("#CategoryBox #SiteCat").stop();
           $('#CategoryBox #SiteCat').removeAttr('style');
           $('#CategoryBox #SiteCat').css('display','block');
         });
       }
    }
    $(document).ready(function() {
      sidecatresponsive()
    });

    function mobileToggleMenu2(){
    if ($(window).width() < 1270){
      $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );
      $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
      $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
         $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');

      });
    }
    else
    {
      $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").removeClass('toggle')
      $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").removeClass('active');
      $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").remove();
    }
  }
  $(document).ready(mobileToggleMenu2);
  $(window).resize(function(){mobileToggleMenu2();});

  function mobileToggleMenu3(){
    if ($(window).width() < 1270){
      $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );
      $("#CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle');
      $("#CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
         $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow');

      });
    }
    else
    {
      $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").removeClass('toggle')
      $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").removeClass('active');
      $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").remove();
    }
  }
  $(document).ready(mobileToggleMenu3);
  $(window).resize(function(){mobileToggleMenu3();});
